export default __webpack_public_path__ + "static/blob6-34002a5bc5ae83a1d0d17e179cd83441.svg";